import React from 'react';
import './home.css';

// ─── Home Page Signals ────────────────────────────────────────────────────────
// Single quote:  { id, quote, source, sourceUrl, linkText, filterIndustries, paperLink, externalLink }
// Multi-line:    replace quote/source/sourceUrl with lines: [{ text, source, sourceUrl }, ...]
// paperLink: { text, section }           — navigates to /paper/:section
//            { text, section, article }  — navigates to /paper/:section/:article
// externalLink: { text, url }            — opens external URL in new tab
const SIGNALS = [
  {
    id: 5,
    quote: 'A Vancouver startup just raised $5.7M to prevent wildfires before they start — by seeding clouds to neutralize lightning strikes mid-storm. Skyward Wildfire is the world\'s first lightning prevention company, and wildfire season is only getting longer.',
    source: 'Skyward Wildfire — MIT Technology Review',
    sourceUrl: 'https://www.technologyreview.com/2026/03/03/1133848/this-startup-claims-it-can-stop-lightning-and-prevent-catastrophic-wildfires/',
    linkText: 'Open roles at climate & clean tech companies →',
    filters: { industries: ['Energy & Climate'] },
    paperLink: { text: 'Read about it in the Paper →', section: 'energy', article: 'skyward-wildfire-lightning' },
  },
  {
    id: 4,
    quote: 'If these drugs turn out to be safe and efficacious for treatment of substance-use disorder, because they are so broadly used for other reasons in our society, they would just automatically, de facto, become the most widely prescribed pharmacotherapy for addiction.',
    source: 'Dr. W. Kyle Simmons, Oklahoma State University — CNN Health',
    sourceUrl: 'https://www.cnn.com/2026/03/04/health/glp1-addiction-treatment',
    linkText: 'These pharma companies are hiring →',
    filters: { industries: ['Biotechnology', 'Healthcare'] },
    paperLink: { text: 'Read more in the Paper →', section: 'meds', article: 'glp1-addiction' },
  },
  {
    id: 3,
    lines: [
      {
        text: 'Defense stocks often rise at the onset of fighting and retract as conflicts stabilize. The rapid success of U.S. forces suggests a potentially quicker end to the conflict, leading to a Wednesday morning slide: Northrop Grumman (NOC): ↓ 2%, Lockheed Martin (LMT): ↓ 1.3%, L3Harris (LHX): ↓ 1.1%, RTX: ↓ 0.3%.',
        source: "Barron's",
        sourceUrl: 'https://www.barrons.com/articles/northrop-stock-price-defense-general-dynamics-82187c5e',
      },
      {
        text: 'The iShares U.S. Aerospace & Defense ETF is up 60% over the last 12 months.',
        source: 'iShares ETF Holdings',
        sourceUrl: 'https://www.ishares.com/us/products/239737/ISHARES-US-AEROSPACE-DEFENSE-ETF',
      },
    ],
    linkText: 'iShares U.S. Aerospace & Defense ETF jobs →',
    filters: { industries: ['Aerospace & Defense'] },
    paperLink: { text: 'Read more in the Paper →', section: 'bored', article: 'defense-dip' },
  },
  {
    id: 2,
    lines: [
      {
        text: 'Trump says strikes on Iran could take weeks...',
        source: 'The Post',
        sourceUrl: 'https://www.washingtonpost.com/world/2026/03/02/us-israel-iran-hezbollah-military-strikes-live-updates/#link-T3I7FJNDIBBT5NTB46V3XJT54Y',
      },
      {
        text: 'These Defense Stocks Are Today\'s Movers — Northrop Grumman (+6%), Palantir (+5.8%), RTX/Raytheon (+4.7%), L3Harris (+3.8%), Lockheed Martin (+3.4%).',
        source: "Barron's",
        sourceUrl: 'https://www.barrons.com/articles/stock-movers-b961ba1f?mod=stockoverview',
      },
    ],
    linkText: 'Open roles at defense contractors →',
    filters: { industries: ['Aerospace & Defense'] },
    paperLink: { text: 'Read more in the Paper →', section: 'bored' },
  },
  {
    id: 1,
    quote: 'Total global hedge fund industry assets hit a historic $5 trillion milestone for the first time last year, with net asset inflows of $116 billion, the strongest calendar year for investor inflows since 2007.',
    source: "Barron's",
    sourceUrl: 'https://www.barrons.com/articles/alternative-investments-funds-b489b84e?mod=hp_SP_A_3_1',
    linkText: 'Open roles at hedge funds →',
    filters: { industries: ['Finance'] },
    paperLink: { text: 'Read more in the Paper →', section: 'fish' },
  },
];
// ─────────────────────────────────────────────────────────────────────────────

function HomePage({ onNavigateToJobs, onNavigateToPaper }) {
  return (
    <div className="home-page">
      <header className="home-header">
        <h1>ferl</h1>
        <p className="home-tagline">jobs worth reading about</p>
      </header>

      <main className="home-feed">
        {SIGNALS.map((signal) => (
          <article key={signal.id} className="home-signal">
            <blockquote className="home-quote">
              {signal.lines ? (
                signal.lines.map((line, i) => (
                  <p key={i} className={i > 0 ? 'home-quote-line' : ''}>
                    "{line.text}"{' '}
                    <cite>
                      {line.sourceUrl ? (
                        <a href={line.sourceUrl} target="_blank" rel="noopener noreferrer">
                          — {line.source}
                        </a>
                      ) : (
                        `— ${line.source}`
                      )}
                    </cite>
                  </p>
                ))
              ) : (
                <>
                  <p>"{signal.quote}"</p>
                  {signal.sourceUrl ? (
                    <cite>
                      <a href={signal.sourceUrl} target="_blank" rel="noopener noreferrer">
                        — {signal.source}
                      </a>
                    </cite>
                  ) : (
                    <cite>— {signal.source}</cite>
                  )}
                </>
              )}
            </blockquote>
            <div className="home-signal-links">
              <button
                className="home-jobs-link"
                onClick={() => onNavigateToJobs(signal.filters)}
              >
                {signal.linkText}
              </button>
              {signal.paperLink && (
                <button
                  className="home-paper-link"
                  onClick={() => onNavigateToPaper(
                    signal.paperLink.article
                      ? `${signal.paperLink.section}/${signal.paperLink.article}`
                      : signal.paperLink.section
                  )}
                >
                  {signal.paperLink.text}
                </button>
              )}
            </div>
          </article>
        ))}
      </main>
    </div>
  );
}

export default HomePage;
